const input = {
    username: 'Username',
    password: 'Password',
    email: 'Email',
    phone_number: 'Phone number',
    email_placeholder: 'you@example.com',
    phone_number_placeholder: '123 456 7890',
    username_placeholder: 'yourusername',
    confirm_password: 'Confirm password',
    search_region_code: 'Search country or code',
    backup_code: 'Backup code',
    code: 'Code',
    label_with_optional: '{{label}} (optional)',
    caps_lock_on: 'Caps Lock is on',
    password_strength: {
        label: 'Password strength: {{strength}}',
        weak: 'Weak',
        fair: 'Fair',
        good: 'Good',
        strong: 'Strong',
    },
};
export default Object.freeze(input);
